import { TRACK_VIEWED_AD_API_BASE, V2_CLIENT_CODE_KEY } from '../Constants/APIConstantsV2';

const postViewedItem = (parameters) => {
    let url = new URL(`${TRACK_VIEWED_AD_API_BASE}`);

    return fetch(url, {
        
            method: "post",
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'x-functions-key': V2_CLIENT_CODE_KEY
            },
          
            //make sure to serialize your JSON body
            body: JSON.stringify({ ...parameters  })
         
    });
}

export default postViewedItem;